/* eslint-disable */

/* CONSTANTS */

export const getCountryStart = (countryId) => async (dispatch) => {
  dispatch({ type: 'GET_COUNTRY_START' });
  let country = await getCountry(countryId);

  dispatch({ type: 'GET_COUNTRY_SUCCESS', payload: country });
};

export const resetCurrentCountry = () => async (dispatch) => {
  dispatch({ type: 'RESET_COUNTRY' });
};

export const getCountry = async (countryId) => {
  return await fetch(process.env.REACT_APP_API_URL + "/api/countries/" + countryId, {
    method: 'GET',
    credentials: "include",
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
    .then(handleErrors)
    .then(res => res.json())
    .then(data => {
      return data
    })
    .catch(error => {
      console.error(error);
    });
}

export const getCountrySuccess = (countryId, dispatch) => {
  dispatch({ type: 'GET_COUNTRY_SUCCESS' });
};

export const getCountryFail = (countryId, dispatch) => {
  dispatch({ type: 'GET_COUNTRY_FAIL' });
};

const handleErrors = (response) => {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}

const handleCatchedErrors = err => {
  throw Error(err);
};

export const getCountries = () => async (dispatch) => {
  dispatch({ type: 'GET_COUNTRIES_START' });
  return await fetch(process.env.REACT_APP_API_URL + "/api/countries/", {
    method: 'GET',
    credentials: "include",
    headers: {
      'Content-Type': 'application/json; charset=utf-8'
    }
  })
    .then(handleErrors)
    .then(async res => res.json())
    .then(async countries => {
      getCountriesSuccess(countries, dispatch);
      return countries
    })
    .catch(error => {
      console.error(error);
      getCountriesFail(error, dispatch);
    });
}

export const getCountriesSuccess = (countries, dispatch) => {
  dispatch({ type: 'GET_COUNTRIES_SUCCESS', payload: countries });
};

export const getCountriesFail = (error, dispatch) => {
  dispatch({ type: 'GET_COUNTRIES_FAIL' });
};


// WEBPACK FOOTER //
// ./src/actions/CountryActions.js